const NAME = "MY_PENDING_EMPLOYER_PAGE";

export default NAME;
